export const randomId = () => {
  return Number(String(Date.now()).substr(-7, 7));
};
